/**
 * TanStack Query Provider
 *
 * 默认配置：30s staleTime、5min gcTime、不自动 refetchOnWindowFocus、失败重试 1 次。
 * 在主题/业务场景需要更激进的缓存或刷新策略时可通过 props 重写。
 */

import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const QueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
